export default {"src":"/_next/static/media/crvusd.e65e6479.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};